import { type ReactNode } from 'react';
import styles from './callOutBox.module.scss';
export const CallOutBox = ({ children }: IProps) => {
	if (!children) {
		return null;
	}

	return <span className={styles.box}>{children}</span>;
};

interface IProps {
	children: ReactNode | ReactNode[];
}

export default CallOutBox;
